import { render } from "./Timeline.vue?vue&type=template&id=339046bd"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"
script.render = render

export default script